import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const getSearchedUser = async (query) => {
	try {
		const { data } = await ApiClient.GET('userSearch', `?search=${query}`);
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.error) {
			toastError(response.data.error);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

const getRequestChannel = async (stompClient) => {
	try {
		const { data } = await ApiClient.GET('getConversationTopic');
		return data;
	} catch ({ response }) {
		if (response.status === 401) {
			stompClient.disconnect(function () {});
		}
	}
};

const onReviseTask = async (body, taskId) => {
	try {
		const { data } = await ApiClient.POST('reviseTask', body, taskId);
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.message) {
			toastError(response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

const onAddNewComment = async (body) => {
	try {
		const { data } = await ApiClient.POST('postOnTask', body, '?fromTimeline=false');
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.message) {
			toastError(response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

const onAddNewReply = async (body) => {
	try {
		const { data } = await ApiClient.POST('commentOnTask', body, '?fromTimeline=false');
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.message) {
			toastError(response.data.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export default {
	getSearchedUser,
	getRequestChannel,
	onReviseTask,
	onAddNewComment,
	onAddNewReply
};
